import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Table from '../../../core-components/theme/components/Table/Table';
import NoDataView from '../../../globalComponents/NoDataView/NoDataView';
import { columns } from '../helper/tableHelper';
import { useLogbookTemplateTable } from '../hooks/useLogbookTemplateTable';
import { useLogbookEditPrefetch } from '../hooks/useLogbookEditPrefetch';
import { DATA_INPUT_RULES, anyPlant, useCan } from '../../../access';

export default function LogbookTemplateTable({ searchString, isPending }: any) {
    const { t } = useTranslation();
    const { logbookTemplates, lastElementRef, tableContainerRef } = useLogbookTemplateTable(searchString);
    const canEdit = useCan(DATA_INPUT_RULES.createLogbookTemplate, anyPlant);
    const canDelete = useCan(DATA_INPUT_RULES.deleteLogbookTemplate, anyPlant);
    const prefetchForEdit = useLogbookEditPrefetch();
    const tableColumns = columns(t, { canEdit, canDelete }, prefetchForEdit);
    const hasNoData = !isPending && (!logbookTemplates || logbookTemplates.length === 0);

    return (
        <Box ref={tableContainerRef} sx={{ display: 'flex', flexDirection: 'column', height: '100%', opacity: isPending ? '0.3' : '1' }}>
            {hasNoData ? (
                <NoDataView message={t('common.noDataAvailable', 'No data available')} />
            ) : (
                <Table
                    stickyHeader
                    rows={logbookTemplates}
                    columns={tableColumns}
                    lastRowRef={lastElementRef}
                />
            )}
        </Box>
    );
}